import React, { useState } from 'react';
import { ChevronDown, Phone, Mail } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'Ce este certificatul constatator?',
      answer: 'Certificatul constatator este un document oficial emis de <strong>Oficiul Național al Registrului Comerțului (ONRC)</strong> care atestă informațiile actuale despre o firmă: denumire, sediu social, asociați, administratori, capital social, obiect de activitate și starea firmei.'
    },
    {
      question: 'Cât durează să primesc certificatul constatator?',
      answer: 'Certificatul este emis <strong>automat</strong> după confirmarea plății. De regulă îl primești în <strong>aproximativ 5 minute</strong>, pe email, în format PDF.'
    },
    {
      question: 'Certificatele sunt oficiale și valabile legal?',
      answer: '<strong>DA, 100% oficiale!</strong> Certificatele sunt descărcate direct din <strong>portalul ONRC (Oficiul Național al Registrului Comerțului)</strong> și conțin ștampila electronică oficială. Sunt valabile atât pentru persoane juridice cât și pentru persoane fizice.'
    },
    {
      question: 'Ce documente am nevoie pentru comandă?',
      answer: 'Ai nevoie doar de <strong>CUI-ul (Codul Unic de Identificare)</strong> al firmei pentru care dorești certificatul. Restul datelor sunt completate automat din baza de date ONRC.'
    },
    {
      question: 'Care este valabilitatea certificatului constatator?',
      answer: 'Certificatul constatator <strong>nu are o valabilitate fixă</strong> stabilită prin lege. Însă, majoritatea instituțiilor acceptă certificate emise în <strong>ultimele 30 de zile</strong>. Pentru licitații publice, verifică cerințele specifice din documentația de atribuire.'
    },
    {
      question: 'Ce metode de plată acceptați?',
      answer: 'Acceptăm plata cu <strong>card bancar</strong> (Visa, Mastercard, Maestro) prin intermediul platformei <strong>Stripe</strong>, lider global în securitatea plăților online. Toate tranzacțiile sunt criptate SSL și procesate în conformitate cu standardele PCI-DSS.'
    },
    {
      question: 'Pot solicita certificat pentru orice persoană juridică sau fizică din România?',
      answer: '<strong>DA, pentru toate tipurile de persoane juridice sau fizice care sunt existente la Registrul Comerțului!</strong> Platforma noastră automatizează procesul de obținere a certificatelor. Nu contează unde este înregistrată firma – certificatul este emis automat.'
    },
    {
      question: 'Primesc factură fiscală pentru plată?',
      answer: 'Da, veți primi pe mail factura fiscală.'
    },
    {
      question: 'Ce se întâmplă dacă introduc date greșite (CUI/CNP)?',
      answer: 'Platforma noastră <strong>validează automat</strong> datele introduse înainte de a permite plata. Dacă CUI-ul sau CNP-ul nu sunt valide sau nu corespund cu datele existente în Registrul Comerțului, veți primi <strong>eroare instant</strong> și nu veți putea continua procesul. Astfel, <strong>nu există risc să plătiți pentru un certificat incorect</strong>.'
    },
    {
      question: 'Sunteți ONRC oficial? De ce să cer certificatul prin voi?',
      answer: '<strong>NU</strong>, nu suntem instituție guvernamentală. Suntem o <strong>platformă software</strong> care automatizează procesul de obținere a certificatelor.<br><br><strong>Avantajele sunt:</strong><br><svg class="inline w-4 h-4 text-emerald-600 mr-1 -mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><strong>Fără cont necesar</strong> – Noi facem tot procesul pentru dvs.<br><svg class="inline w-4 h-4 text-emerald-600 mr-1 -mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><strong>Fără așteptare</strong> – Certificat în aproximativ 5 minute<br><svg class="inline w-4 h-4 text-emerald-600 mr-1 -mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><strong>Fără portaluri greoaie</strong> – Tot procesul 100% online, în câțiva pași'
    },
    {
      question: 'Certificatul primit este document original?',
      answer: 'Da, certificatul primit este <strong>documentul oficial emis de ONRC</strong>, semnat electronic cu semnătură calificată. Are <strong>aceeași valoare juridică</strong> ca și varianta tipărită.'
    },
    {
      question: 'Oferiți suport pentru întrebări suplimentare?',
      answer: '<strong>DA, suport complet!</strong><br><br><strong>Telefon:</strong> <a href="tel:+40756888282" class="text-emerald-600 hover:underline font-semibold">+40 756 888 282</a><br><strong>Email:</strong> <a href="mailto:contact@constatatoare.ro" class="text-emerald-600 hover:underline font-semibold">contact@constatatoare.ro</a><br><br>Echipa noastră vă ajută cu orice problemă legată de comandă, plată sau descărcarea certificatului.'
    }
  ];

  return (
    <section id="intrebari" className="bg-gradient-to-br from-gray-50 to-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Întrebări Frecvente (FAQ)
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Răspunsuri la cele mai comune întrebări despre serviciul nostru
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md"
            >
              {/* Question Button */}
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full flex items-center justify-between p-5 sm:p-6 text-left focus:outline-none"
                aria-expanded={openIndex === index}
              >
                <span className="text-base sm:text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 sm:w-6 sm:h-6 text-emerald-600 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                />
              </button>

              {/* Answer Content (mereu in DOM pentru crawleri, ascuns vizual cu max-height) */}
              <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-200 ${openIndex === index ? 'pb-5 sm:pb-6 max-h-[500px]' : 'max-h-0'}`}>
                <div
                  className="text-gray-700 leading-relaxed text-sm sm:text-base"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div className="mt-12 text-center bg-emerald-50 rounded-xl p-6 border border-emerald-200">
          <p className="text-gray-700 mb-3">
            <strong>Încă ai nelămuriri?</strong> Echipa noastră este aici să te ajute!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm">
            <a
              href="tel:+40756888282"
              className="flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold"
            >
              <Phone className="w-4 h-4" />+40 756 888 282
            </a>
            <span className="hidden sm:inline text-gray-400">•</span>
            <a
              href="mailto:contact@constatatoare.ro"
              className="flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold"
            >
              <Mail className="w-4 h-4" />contact@constatatoare.ro
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
